import React, { PureComponent } from 'react';

import {
    CCallout,
    CLink,
    CButton,
    CTooltip,
    CPopover,
    CSelect,
    CCollapse
} from '@coreui/react';

import CIcon from '@coreui/icons-react';

import EmployeeRow from './EmployeeRow';

import {
    filterProjectByArea,
    calculateTotalDuration
} from '../helpers/checkDataBuilder';

import { helps } from 'src/_helpers';

class ProjectCard extends PureComponent {

    getSelectedArea() {

        const {
            selected_areas,
            project
        } = this.props;

        return (
            selected_areas[
                project.id
            ] || ''
        );
    }

    getProjectData() {

        const {
            project,
            dataCache
        } = this.props;

        const selectedAreaId =
            this.getSelectedArea();

        return filterProjectByArea(
            project,
            selectedAreaId,
            dataCache.positionsByArea
        );
    }

    renderProjectManagers() {

        const {
            project,
            history
        } = this.props;

        if (
            helps.isEmpty(
                project.assigns
            )
        ) {
            return null;
        }

        return (
            <div className="text-muted">

                <u>
                    <i>
                        Phụ Trách:
                    </i>
                </u>

                <ul>

                    {
                        project.assigns.map(
                            assign => (

                                <li
                                    key={
                                        assign.value
                                    }
                                >

                                    <CPopover
                                        content={
                                            assign.label
                                        }
                                    >

                                        <CLink
                                            className="
                                                text-muted
                                            "
                                            style={{
                                                fontSize:
                                                    '14px'
                                            }}
                                            onClick={() =>
                                                history.push(
                                                    `/employees/view/${assign.value}`
                                                )
                                            }
                                        >
                                            {
                                                assign.label
                                            }
                                        </CLink>

                                    </CPopover>

                                </li>
                            )
                        )
                    }

                </ul>

            </div>
        );
    }

    renderAreaSelect() {

        const {
            project,
            handleChangeAreas
        } = this.props;

        const areas =
            project.areas || [];

        if (
            helps.isEmpty(
                areas
            )
        ) {
            return null;
        }

        return (
            <CSelect
                name={
                    'area-' +
                    project.id
                }
                value={
                    this.getSelectedArea()
                }
                onChange={e =>
                    handleChangeAreas(
                        e,
                        project.id
                    )
                }
            >

                <option value="">
                    - Chọn Khu Vực -
                </option>

                {
                    areas.map((area, cntArea) => (

                        <option
                            key={area.id + '-' +cntArea}
                            value={area.id}
                        >
                            {area.name}
                        </option>

                    ))
                }

            </CSelect>
        );
    }

    renderExternalChecks() {

        const {
            project,
            employees,
            user,
            history,
            handleDelete
        } = this.props;

        const {
            projectChecks
        } =
            this.getProjectData();

        if (
            helps.isEmpty(
                projectChecks
            )
        ) {
            return null;
        }

        const employeeIds =
            new Set(
                (
                    project.employees ||
                    []
                ).map(
                    item =>
                        item.employee_id
                )
            );

        const externalChecks =
            projectChecks.filter(
                check =>
                    !employeeIds.has(
                        check.employee_id
                    )
            );

        return externalChecks.map(
            (
                check,
                index
            ) => {

                const employee =
                    employees.find(
                        emp =>
                            emp.employee_id ===
                            check.employee_id
                    );

                if (!employee) {
                    return null;
                }

                return (

                    <EmployeeRow

                        key={
                            check.id
                        }

                        employee={
                            employee
                        }

                        project={
                            project
                        }

                        externalCheck={
                            check
                        }

                        user={
                            user
                        }

                        history={
                            history
                        }

                        handleDelete={
                            handleDelete
                        }

                        {...this.props}

                    />

                );
            }
        );
    }

    renderEmployees() {

        const {
            employees
        } =
            this.getProjectData();

        if(!employees) return null;    

        return employees.map(
            (
                employeeData,
                index
            ) => (

                <EmployeeRow

                    key={
                        employeeData
                            .employee_id
                    }

                    employeeData={
                        employeeData
                    }

                    rowIndex={
                        index
                    }

                    {...this.props}

                />

            )
        );
    }

    render() {

        const {
            project,
            history,
            is_hide,
            handleHide
        } = this.props;

        const hidden =
            is_hide.has(
                project.id
            );

        const data =
        this.getProjectData();

        const employees =
            data?.employees || [];

        const projectChecks =
            data?.projectChecks || [];

        const totalDuration =
            calculateTotalDuration(
                employees
            );

        return (

            <tr>

                <td width="20%">

                    <CCallout
                        color={
                            project.color
                        }
                        className="
                            h-100
                            align-middle
                        "
                        style={{
                            minHeight:
                                '40px'
                        }}
                    >

                        <CLink
                            className="
                                text-dark
                                mt-2
                                font-weight-bold
                            "
                            style={{
                                fontSize:
                                    '18px'
                            }}
                            onClick={() =>
                                history.push(
                                    `/projects/view/${project.id}`
                                )
                            }
                        >
                            {
                                project.name
                            }
                        </CLink>

                        {
                            this.renderProjectManagers()
                        }

                        {
                            this.renderAreaSelect()
                        }

                    </CCallout>

                </td>

                <td width="30">

                    <CTooltip
                        content={
                            hidden
                                ? 'Hiện'
                                : 'Ẩn'
                        }
                    >

                        <CButton
                            color="secondary"
                            size="sm"
                            className="ml-2"
                            onClick={() =>
                                handleHide(
                                    project.id
                                )
                            }
                        >

                            <CIcon
                                name={
                                    hidden
                                        ? 'cil-chevron-bottom'
                                        : 'cil-chevron-top'
                                }
                            />

                        </CButton>

                    </CTooltip>

                </td>

                <td>

                    <CCollapse
                        show={!hidden}
                    >

                        <table
                            className="table"
                        >

                            <tbody>

                                {
                                    this.renderExternalChecks()
                                }

                                {
                                    this.renderEmployees()
                                }

                                <tr>

                                    <td
                                        colSpan={
                                            5
                                        }
                                    >

                                        <div
                                            className="
                                                text-right
                                            "
                                        >

                                            <h6
                                                className="
                                                    m-1
                                                "
                                            >

                                                <span
                                                    className="
                                                        p-2
                                                        bg-secondary
                                                        text-dark
                                                    "
                                                >

                                                    <i>
                                                        Tổng
                                                        giờ
                                                        công:
                                                    </i>

                                                    {' '}

                                                    <b>

                                                        {
                                                            (
                                                                totalDuration /
                                                                60
                                                            ).toFixed(
                                                                2
                                                            )
                                                        }

                                                    </b>

                                                </span>

                                            </h6>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </CCollapse>

                </td>

            </tr>

        );
    }
}

export default ProjectCard;